import React, {useEffect, useState,useRef} from 'react';
import {
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonIcon,
    IonLabel, IonTabs, IonPage, IonModal, IonContent
} from '@ionic/react';
import {Route, Redirect,useLocation } from 'react-router-dom';
import {
    briefcaseOutline,
    briefcase, calendarOutline, calendar, cashOutline, cash,
    clipboardOutline,
    clipboard,
    ellipsisHorizontal,
    heartOutline,
    heart,
    homeOutline,
    home, newspaperOutline, newspaper
} from "ionicons/icons";
import {useHistory} from "react-router-dom";
import AdminHeaderAfterLoginComponent from "./AdminHeaderAfterLoginComponent";
import AdminHomePage from "./AdminHomePage";
import AdminJobPortalPage from "./AdminJobPortalPage";
import AdminMatrimonialPage from "./AdminMatrimonialPage";
import AdminAssignmentsPage from "./AdminAssignmentsPage";
import AdminNewsletterPage from "./AdminNewsletterPage";
import AdminEventsPage from "./AdminEventsPage";
import AdminContributePage from "./AdminContributePage";
import AdminMembershipPage from "./AdminMembershipPage";
import AdminUserManagementPage from "./AdminUserManagementPage";
import NotificationListener from "../../hooks/NotificationListener";
import NotificationSheet from "../../components/NotificationSheet";

const AdminDashboardPage = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);
    const [currentPath,setCurrentPath] = useState('/dashboard/home')
    const [hideHeader, setHideHeader] = useState(false);
    const [showMoreSheet, setShowMoreSheet] = useState(false);
    const history = useHistory();
    const menuRef = useRef(null);
    const bottomTabSectionRef = useRef(null);
    const {pathname} = useLocation();

    useEffect(() => {
        setCurrentPath(pathname);
    }, [pathname]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 1000);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const gotToPage = (path,type)=>{
        setCurrentPath(type)
        history.replace(path);
        setShowMoreSheet(false);
        setHideHeader(false);
        closeMenu();
    }

    const callFunctionToSetCurrentPath = (path) =>{
        setCurrentPath(path);
        setShowMoreSheet(false);
        setHideHeader(false);
        closeMenu();
    }

    const closeMenu = () => {
        const menu = menuRef.current;
        if (menu) {
            menu.close()
        }
    };

    const callFunctionToOpenShowMoreSheet = () => {
        setShowMoreSheet(!showMoreSheet);
    };

    return (
        <IonTabs>
            <IonRouterOutlet>
                <Route path="/dashboard/" render={() => (
                    <IonPage>
                        {/* Common header always visible */}
                        <AdminHeaderAfterLoginComponent menuRef={menuRef} currentPath={currentPath} setCurrentPath={setCurrentPath} hideHeader={hideHeader} pageId={"main-menu-content"} />
                        {/* Nested outlet for tab pages */}
                        <IonRouterOutlet id="main-menu-content">
                            <Route exact path="/dashboard/home" component={AdminHomePage} />
                            <Route exact path="/dashboard/users" component={AdminUserManagementPage} />
                            <Route exact path="/dashboard/job-portal" component={AdminJobPortalPage} />
                            <Route exact path="/dashboard/matrimonial" component={AdminMatrimonialPage} />
                            <Route exact path="/dashboard/assignments" component={AdminAssignmentsPage} />
                            <Route exact path="/dashboard/newsletter" component={AdminNewsletterPage} />
                            <Route exact path="/dashboard/events" component={AdminEventsPage} />
                            <Route exact path="/dashboard/contribute" component={AdminContributePage} />
                            <Route exact path="/dashboard/membership" component={AdminMembershipPage} />
                            <Redirect exact from="/dashboard" to="/dashboard/home" />
                        </IonRouterOutlet>
                        <NotificationListener/>
                        <NotificationSheet/>
                    </IonPage>
                )} />
            </IonRouterOutlet>
            {/* Bottom Tabs - Conditionally rendered */}
            <IonTabBar
                slot="bottom"
                style={{display: !isMobile ? 'none' : ''}}
                ref={bottomTabSectionRef}
                className={`custom-tabbar main-tab-bar`}
            >
                <IonTabButton tab="home" className={"custom-ripple-color"} onClick={()=>callFunctionToSetCurrentPath('/dashboard/home')} href="/dashboard/home">
                    <IonIcon icon={currentPath === '/dashboard/home' ? home : homeOutline} />
                    <IonLabel>Home</IonLabel>
                </IonTabButton>

                <IonTabButton tab="job" className={"custom-ripple-color"} onClick={()=>callFunctionToSetCurrentPath('/dashboard/job-portal')} href="/dashboard/job-portal">
                    <IonIcon icon={currentPath === '/dashboard/job-portal' ? briefcase : briefcaseOutline} />
                    <IonLabel>Job</IonLabel>
                </IonTabButton>

                <IonTabButton tab="assignments" className={"custom-ripple-color"} onClick={()=>callFunctionToSetCurrentPath('/dashboard/assignments')} href="/dashboard/assignments">
                    <IonIcon icon={currentPath === '/dashboard/assignments' ? clipboard : clipboardOutline} />
                    <IonLabel>Assignments</IonLabel>
                </IonTabButton>

                <IonTabButton tab="more" className={`custom-ripple-color ${(currentPath === '/dashboard/matrimonial' || currentPath === '/dashboard/events' || currentPath === '/dashboard/newsletter' || currentPath === '/dashboard/contribute') ? 'tab-selected' : ''}`} onClick={()=> callFunctionToOpenShowMoreSheet()}>
                    <IonIcon icon={ellipsisHorizontal} />
                    <IonLabel>More</IonLabel>
                    <IonModal
                        isOpen={showMoreSheet}
                        onDidDismiss={() => setShowMoreSheet(false)}
                        breakpoints={[0, 0.2]}
                        initialBreakpoint={0.2}
                        className="more-sheet-modal">
                        <IonContent className="ion-padding">
                            <div className="more-sheet-grid">
                                <div onClick={() => gotToPage('/dashboard/matrimonial', '/dashboard/matrimonial')}
                                     className={`more-sheet-item ${currentPath === '/dashboard/matrimonial' ? 'active' : ''}`}>
                                    <div className="more-tile">
                                        <IonIcon
                                            icon={currentPath === '/dashboard/matrimonial' ? heart : heartOutline}/>
                                    </div>
                                    <span>Matrimonial</span>
                                </div>
                                <div onClick={() => gotToPage('/dashboard/events', '/dashboard/events')}
                                     className={`more-sheet-item ${currentPath === '/dashboard/events' ? 'active' : ''}`}>
                                    <div className="more-tile">
                                        <IonIcon
                                            icon={currentPath === '/dashboard/events' ? calendar : calendarOutline}/>
                                    </div>
                                    <span>Events</span>
                                </div>
                                <div onClick={() => gotToPage('/dashboard/newsletter', '/dashboard/newsletter')}
                                     className={`more-sheet-item ${currentPath === '/dashboard/newsletter' ? 'active' : ''}`}>
                                    <div className="more-tile">
                                        <IonIcon
                                            icon={currentPath === '/dashboard/newsletter' ? newspaper : newspaperOutline}/>
                                    </div>
                                    <span>Newsletter</span>
                                </div>
                                <div onClick={() => gotToPage('/dashboard/contribute', '/dashboard/contribute')}
                                     className={`more-sheet-item ${currentPath === '/dashboard/contribute' ? 'active' : ''}`}>
                                    <div className="more-tile">
                                        <IonIcon
                                            icon={currentPath === '/dashboard/contribute' ? cash : cashOutline}/>
                                    </div>
                                    <span>Contribute</span>
                                </div>
                            </div>
                        </IonContent>
                    </IonModal>
                </IonTabButton>
            </IonTabBar>
        </IonTabs>
    );
};

export default AdminDashboardPage;